import { Controller } from 'stimulus';

export default class extends Controller {
  //nicked this from https://www.jorgemanrubia.com/2019/02/16/form-validations-with-html5-and-modern-rails/
  //https://github.com/jorgemanrubia/rails-form-validations-example/blob/master/app/javascript/controllers/form_controller.js
  static targets = ['form', 'tempCheck', 'collegeCheck', "collegeName", "classificationSelector", "teamSelector", "collegeNameInput"];

  connect() {
    this.element.setAttribute('novalidate', true)
    this.element.addEventListener('blur', this.onBlur, true)
    this.element.addEventListener('keyup', this.onBlur, true)
    this.element.addEventListener('submit', this.onSubmit)
    this.element.addEventListener('ajax:beforeSend', this.onSubmit)
  }

  disconnect () {
    this.element.removeEventListener('blur', this.onBlur)
    this.element.removeEventListener('keyup', this.onBlur)
    this.element.removeEventListener('submit', this.onSubmit)
    this.element.removeEventListener('ajax:beforeSend', this.onSubmit)
  }

  onBlur = (event) => {
    this.validateField(event.target)
  }

  onSubmit = (event) => {
    if (!this.validateForm()) {
      event.preventDefault()
      this.firstInvalidField.focus()
    }
  }

  popTheModal() {
    let theFormIsValid = this.validateForm()
    if (theFormIsValid) {
      $("#staticBackdrop").modal()
    }
  }

  submitFromModal() {
    $('#tue-application-form').submit()
  }

  validateForm () {
    let isValid = true
    // Not using `find` because we want to validate all the fields
    this.formFields.forEach((field) => {
      if (this.shouldValidateField(field) && !this.validateField(field)) isValid = false
    })
    return isValid
  }

  validateField (field) {
    if (!this.shouldValidateField(field))
      return true
    const isValid = field.checkValidity()
    field.classList.toggle("is-invalid", !isValid);
    this.refreshErrorForInvalidField(field, isValid)
    return isValid
  }

  shouldValidateField (field) {
    if (field.type === undefined ){
      return false
    }
    return !field.disabled && !['file', 'reset', 'submit', 'button'].includes(field.type)
  }

  refreshErrorForInvalidField (field, isValid) {
    this.removeExistingErrorMessage(field)
    if (!isValid)
      this.showErrorForInvalidField(field)
  }

  removeExistingErrorMessage (field) {
    const fieldContainer = field.closest('.field')
    if(!fieldContainer)
      return;

    const existingErrorMessageElement = fieldContainer.querySelector('.error')

    if (existingErrorMessageElement)
      existingErrorMessageElement.parentNode.removeChild(existingErrorMessageElement)
  }

  showErrorForInvalidField (field) {
    //skipping filling up the form with text until it fails server side validation
    //field.insertAdjacentHTML('afterend', this.buildFieldErrorHtml(field))
  }

  buildFieldErrorHtml (field) {
    return `<span class="error">${field.validationMessage}</span>`
  }

  get formFields () {
    return Array.from(this.element.elements)
  }

  get firstInvalidField () {
    return this.formFields.find(field => !field.checkValidity())
  }

  updateCollege(event) {
    if (event.target.value.includes('College')) {
      this.teamSelectorTarget.classList.add("d-none")
      this.collegeNameTarget.classList.remove("d-none")
      this.collegeNameInputTarget.required = true
    } else {
      this.collegeNameInputTarget.value = ''
      this.collegeNameInputTarget.required = false
      this.collegeNameTarget.classList.add("d-none")
      this.teamSelectorTarget.classList.remove("d-none")
    }
  }

  updateTemp(event) {
    if (event.target.checked) {
      this.collegeCheckTarget.checked = false
      this.collegeNameTarget.classList.add("d-none")
      this.collegeNameInputTarget.required = false
      this.teamSelectorTarget.classList.remove("d-none")
    } else {
      this.collegeNameTarget.classList.add("d-none")
      this.teamSelectorTarget.classList.remove("d-none")
    }

  }
}
